import Marquee from 'react-fast-marquee';
import { WheatOff } from 'lucide-react';
import { useLang } from '../i18n';

const EditorialMarquee = ({ dark = false }) => {
  const { t } = useLang();
  const items = t('marquee');
  return (
    <div className={`py-8 md:py-10 border-y ${dark ? 'bg-[#111827] text-[#F7F5F0] border-white/10' : 'bg-muted border-foreground/10'}`} data-testid="editorial-marquee">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl px-8 md:px-12 whitespace-nowrap">{item}</span>
            <WheatOff className="w-6 h-6 md:w-8 md:h-8 text-secondary shrink-0" strokeWidth={1.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
